import React from 'react'

import styles from './menu-footer.css'

import { menuItemsFooter } from 'layout/components/menu/config'
import MenuItem from 'layout/components/menu/item/menu-item'
import { useSelector } from 'react-redux'
const MenuFooter = ({ handleMenuItemClick }) => {
  const { info: userInfo } = useSelector(state => state.user)
  const { info: tenantInfo } = useSelector(state => state.tenant)

  const buildMenuItems = () => {
    return menuItemsFooter(userInfo, tenantInfo).map((menuItemData) => {
      const { name } = menuItemData
      return (
        <MenuItem key={name} {...menuItemData} handleItemClick={handleMenuItemClick} />
      )
    })
  }

  const menuItems = buildMenuItems()

  return (
    <div className={styles.container}>
      {menuItems}
    </div>
  )

}

export default MenuFooter
